module.exports = __webpack_public_path__ + "img/img-desk.122e9eba.png";